export default __webpack_public_path__ + "static/media/adriana_castro.1525ccde.png";